import { isBarberSessionView } from '../../../../infra/session';
import { getFeatureFlags } from '../../../../infra/feature-flags';
export var canUserOptIn2FA = function (session) {
    var _a = getFeatureFlags(), isTwoFaFlagEnabled = _a["2FaEnable"], isTwoFaPhaseOneFlagEnabled = _a["2FaPhaseOne"];
    return isTwoFaFlagEnabled && isTwoFaPhaseOneFlagEnabled && isBarberSessionView(session === null || session === void 0 ? void 0 : session.view);
};
